module.exports = __webpack_public_path__ + "assets/people.9e470ff3.svg";